import { useEffect } from "react";
import {
  COOKIE_CONSENT_EVENT,
  type ConsentState,
  loadConsentState,
} from "@/lib/posthog";
import { updateGoogleConsent } from "@/lib/googleTag";

export default function GoogleTagLifecycle() {
  useEffect(() => {
    const syncGoogleTag = (state: ConsentState | null) => {
      if (!state) {
        updateGoogleConsent({ analytics: false, marketing: false });
        return;
      }

      updateGoogleConsent(state);
    };

    const handleConsentChanged = (event: Event) => {
      syncGoogleTag((event as CustomEvent<ConsentState>).detail ?? null);
    };

    syncGoogleTag(loadConsentState());
    window.addEventListener(COOKIE_CONSENT_EVENT, handleConsentChanged);

    return () => {
      window.removeEventListener(COOKIE_CONSENT_EVENT, handleConsentChanged);
    };
  }, []);

  return null;
}
